import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import fr from './locales/fr.json'
import ar from './locales/ar.json'

const messages = {
  en,
  fr,
  ar
}

const storedLocale = localStorage.getItem('lang') || 'fr'

const i18n = createI18n({
  legacy: false, // Pour Vue 3
  locale: storedLocale,
  fallbackLocale: 'fr',
  globalInjection: true,
  messages
})

if (storedLocale === 'ar') {
  document.documentElement.setAttribute('dir', 'rtl')
} else {
  document.documentElement.setAttribute('dir', 'ltr')
}

export default i18n
